//常用快捷函数封装
export default {
	//转换时间为时间戳
	transTime(time) {
		var str = time
		var a = str.split("T").join(" ")
		var b = a.substring(0, 19)
		var c = b.replace(/-/g, "/")
		var date = new Date(c)
		return date.getTime()
	},
	getLocalTime(nS) {//时间戳转为本地时间
		return new Date(parseInt(nS)).toLocaleString('chinese', { hour12: false });
	},
	//取时间字符串T之前的部分
	timeToymd(val) {
		return val.split('T')[0];
	},
	//带T时间转为正常时间
	Ttime2nomarl(time) {
		const date = new Date(time);
		let y = date.getFullYear();
		let m = date.getMonth() + 1;
		m = m < 10 ? ('0' + m) : m;
		let d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		let h = date.getHours();
		let minute = date.getMinutes();
		minute = minute < 10 ? ('0' + minute) : minute;
		let second = date.getSeconds();
		second = second < 10 ? ('0' + second) : second;
		return `${y}-${m}-${d}  ${h}:${minute}:${second}`;
	},
	// 时间格式化
	// timestamp 中国标准时间转为Y-M-D HH:mm:ss格式
	timestampToymd(timestamp) {
		const date = new Date(timestamp);
		let y = date.getFullYear();
		let m = date.getMonth() + 1;
		m = m < 10 ? ('0' + m) : m;
		let d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		let h = date.getHours();
		let minute = date.getMinutes();
		minute = minute < 10 ? ('0' + minute) : minute;
		let second = date.getSeconds();
		second = second < 10 ? ('0' + second) : second;
		return `${y}-${m}-${d}`;

	},

	/**
	 * 数组去重
	 * @param {Object} arr
	 */
	unique(arr) {
		return Array.from(new Set(arr))
	},
	/**
	 * 判断值是否在数组中
	 * @param {Object} elem 待检测元素
	 * @param {Object} arr  待检测数组
	 * @param {Object} i
	 */
	inArray: function (elem, arr) {
		return arr == null ? -1 : arr.indexOf(elem);
	},

	//取得unix时间戳
	getUnixTime() {
		return Math.round(new Date().getTime() / 1000);
	},
	//获得随机字符串
	createNonceStr: function (length) {
		let str = 'abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
		let nonce = '';
		for (let i = 0; i < length; i++) {
			nonce += str.charAt(Math.floor(Math.random() * str.length));
		}
		return nonce;
	},
	/**
	 * 将秒转换为 分:秒
	 * s int 秒数
	 */
	secondstohs(s) {
		//计算分钟
		//算法：将秒数除以60，然后下舍入，既得到分钟数
		let h;
		h = Math.floor(s / 60);
		//计算秒
		//算法：取得秒%60的余数，既得到秒数
		s = s % 60;
		//将变量转换为字符串
		h += '';
		s += '';
		//如果只有一位数，前面增加一个0
		h = (h.length == 1) ? '0' + h : h;
		s = (s.length == 1) ? '0' + s : s;
		return h + ':' + s;
	},
	/*小数转百分数*/
	/*Number()数据类型转换，指定截取转换后的小数点后几位(四舍五入)
	*/
	toPercent(point) {
		var str = Number(point).toFixed(1);
		str += "%";
		return str;
	},
	/*
	/*当前时间加一天
	*/
	 dateAddDay(time,i) {
		//加一天
		let date =new Date(time)
             date.setDate(date.getDate() + i)
            let year = date.getFullYear();
            //补全位数
            let month = (date.getMonth() + 1).toString().padStart(2, '0')
            let day = (date.getDate()).toString().padStart(2, '0')
            return year + "-"+month+"-"+ day;

	}


}

